module.exports = __webpack_public_path__ + "img/9.ebe49697.png";